<template>
    <div class="col-lg-8 col-xlg-9 col-md-7">
        <div class="card">
            <div class="card-header">
                <div class="d-md-flex align-items-center">
                    <div>
                        <h4 class="card-title"><i class="mdi mdi-settings"></i> Settings</h4>
                        <h5 class="card-subtitle">Configure Timezone, Date format, Currency</h5>
                    </div>
                    <div class="ml-auto d-flex no-block align-items-center">
                        <div class="dl">
                            <div class="button-group">
                                <router-link :to="{name: 'viewsettings'}" class="btn btn-outline-secondary waves-effect waves-light"><i class="fas fa-arrow-circle-left"></i> Back</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <form @submit.prevent="handleSubmit" class="form-horizontal">
                <div class="card-body card-blue">
                    <div class="form-group row">
                        <label class="col-sm-3 text-right control-label col-form-label" for="timezone">Timezone</label>
                        <div class="col-sm-7">
                            <select class="custom-select mr-sm-2" id="timezone" v-model="settings.timezone">
                                <option v-bind:key="index" v-bind:value="{value: u.value, offset: u.offset}" v-for="(u, index) in timezones">{{u.text}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 text-right control-label col-form-label" for="dateformat">Date Format</label>
                        <div class="col-sm-5">
                            <select class="custom-select mr-sm-2" id="dateformat" v-model="settings.dateformat">
                                <option v-bind:key="index" v-bind:value="u" v-for="(u, index) in dateformats">{{u}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 text-right control-label col-form-label" for="currency">Currency</label>
                        <div class="col-sm-5">
                            <div class="form-control p-0-0">
                                <currency-select @currency-select="setCurrency" data-vv-as="currency"
                                                 id="curency"
                                                 name="currency"
                                                 ref="reference"
                                                 v-model="settings.currencyid"
                                                 v-validate="'required'">
                                </currency-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="form-group m-b-0 text-right">
                        <div class="button-group">
                            <button @click="saveSetting()" class="btn waves-effect waves-light btn-success" type="button">Save</button>
                            <button @click="reset()" class="btn waves-effect waves-light btn-secondary" type="button">Reset</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../common/Blockie";
    import CurrencySelect from '../../common/CurrencySelect';
    import Timezones from "../../../../models/Timezones";
    import Dateformats from "../../../../models/Dateformats";

    export default {
        name: "Settings",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Blockie, CurrencySelect},
        data() {
            return {
                role: "",
                timezones: [],
                dateformats: [],
                isLoading: false,
                file: File,
                filename: "Upload Logo",
                uploadstatus: '',
                attachments: [],
                imageSrc: null,
                tempImage: null,
                submitted: false,
                settings: {
                    currencyid: null,
                    timezone: null,
                    dateformat: null
                },
                savedSettings: {
                    timezone: null,
                    timezoneoffset: null,
                    dateformat: null,
                    currencyid: null,
                    currencyname: null,
                    currencysymbol: null
                }
            };
        },
        mounted() {
            this.role = this.currentOrg.role;
            this.init();
        },
        methods: {
            async init() {
                this.timezones   = Timezones;
                this.dateformats = Dateformats;
                await this.getSettings();
                this.$refs.reference.currency = {
                    "id": this.savedSettings.currencyid,
                    "name": null,
                    "plural": null,
                    "symbol": this.savedSettings.currencysymbol,
                    "symbol_native": null,
                    "decimals": 2,
                    "rounding": null,
                    "created_at": null
                }
            },
            setCurrency(e) {
                if(e) {
                    this.settings.currencyid = e.id;
                }
            },
            async getSettings() {
                let reply          = await this.$http.get("/org/" + this.currentOrg.id + "/setting");
                this.savedSettings = reply.data;
                this.settings      = {
                    currencyid: this.savedSettings.currencyid,
                    timezone: {
                        value: this.savedSettings.timezone,
                        offset: this.savedSettings.timezoneoffset
                    },
                    dateformat: this.savedSettings.dateformat
                };
            },
            async saveSetting() {
                let obj = {
                    currency_id: this.settings.currencyid,
                    timezone: this.settings.timezone.value,
                    timezone_offset: this.settings.timezone.offset,
                    date_format: this.settings.dateformat
                };

                try {
                    await this.$http.post("/org/" + this.currentOrg.id + "/setting", obj);
                    this.$toastr('success', 'Settings Successfully Saved. Please log out and log in again', 'Success');
                    this.$router.push({name: "viewsettings"});
                } catch(e) {
                    if(e.response.status === 404) {
                        this.$toastr('error', `Can't set Currency. Commodity or Commodity rate or Offer is present`, 'Failed');
                    }
                }


            },
            reset() {
                this.$refs.reference.currency = this.$refs.reference.currency = {
                    "id": this.savedSettings.currencyid,
                    "name": null,
                    "plural": null,
                    "symbol": this.savedSettings.currencysymbol,
                    "symbol_native": null,
                    "decimals": 2,
                    "rounding": null,
                    "created_at": null
                };
                this.getSettings();
            }
        }
    }
</script>

<style scoped>

</style>
